export interface SupabaseConfig {
  url: string
  anonKey: string
}

let supabaseConfig: SupabaseConfig | null = null

export function setSupabaseConfig(config: SupabaseConfig | null): void {
  supabaseConfig = config ? { ...config } : null
}

export function getSupabaseConfig(): SupabaseConfig | null {
  return supabaseConfig ? { ...supabaseConfig } : null
}

export function requireSupabaseConfig(): SupabaseConfig {
  if (!supabaseConfig) {
    throw new Error('Supabase config not set. Call setSupabaseConfig() at startup.')
  }
  return { ...supabaseConfig }
}
